import { render, staticRenderFns } from "./grammar.vue?vue&type=template&id=0815c465&"
import script from "./grammar.vue?vue&type=script&lang=js&"
export * from "./grammar.vue?vue&type=script&lang=js&"
import style0 from "./grammar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0815c465')) {
      api.createRecord('0815c465', component.options)
    } else {
      api.reload('0815c465', component.options)
    }
    module.hot.accept("./grammar.vue?vue&type=template&id=0815c465&", function () {
      api.rerender('0815c465', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/grammar.vue"
export default component.exports